import { SidenavItem } from '@examdojo/shell';

export const MOBILE_MENU_SHEET_DIALOG_ID = 'mobile-menu-sheet-dialog';

export interface MobileMenuSheetDialogData {
  items: SidenavItem[];
  settingsRoute: string;
}
